module.exports = __webpack_public_path__ + "static/media/pending.ef48ac80.svg";